import React, { useEffect, useState } from 'react';
import { get,post } from '../../helpers/api_helper';
import { useNavigate } from 'react-router-dom';
import {ClipLoader} from 'react-spinners'

export default function Bank_account_opening() {
  const [products, setProducts] = useState([]);
  const [isModalVisible, setModalVisible] = useState(false);
  const [loading, setLoading] = useState(false)
  const [modalData, setModalData] = useState({
    title: '',
    content: [],
  });

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true)
      try {
        const response = await get('/getProducts');
        setProducts(response);
        setLoading(false)
      } catch (error) {
        console.error('Error fetching Products', error);
        setLoading(false)
      }
    };
    fetchData();
  }, []);
  const filteredProducts = products.filter((product)=>product.category === "Refer Upi")
  const showModal = (e, product) => {
    setModalData({
      title: product.modalHeading,
      content: product.benefits.split('\n'),
    });
    setModalVisible(true);
  };

  const hideModal = () => {
    setModalVisible(false);
  };

  return (
    <div className={` mx-auto w-full md:max-w-screen-xl px-2`}>
      <div className="flex justify-end p-1 lg:mx-40">
      </div>
      <div className="my-1">
      {
          loading ?(
            <div className='flex justify-center mt-20'>
              <ClipLoader/>
              </div>
          ):(

            filteredProducts.map((item) => (
              <div key={item._id}>
                <Card {...item} showModal={(e) => showModal(e, item)} updateLinks={item.updateLinks} productId={item._id.toString()}  />
              </div>
            ))
          )
        }
      </div>
      <div
        tabIndex="-1"
        aria-hidden="true"
        className={`fixed z-50 bottom-0 left-0 ${isModalVisible ? 'backdrop-brightness-75' : 'hidden'} w-full h-full mx-auto lg:w-2/10 p-4 `}
      >
        <div className="w-full max-w-2xl max-h-full align-middle m-auto">
          <div className="bg-white rounded-lg shadow dark:bg-gray-700 border-2 border-green-500 mt-20">
            <div className="flex items-start justify-between p-4 border-b rounded-t dark:border-gray-600">
              <h3 className="text-xl font-semibold text-gray-900 dark:text-white">{modalData.title}</h3>
              <button
                type="button"
                className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ml-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
                onClick={hideModal}
              >
                <svg className="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
                  <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
                </svg>
                <span className="sr-only">Close modal</span>
              </button>
            </div>
            <div className="max-w-md space-y-1 text-black p-4 list-disc dark:text-gray-400">
              {modalData.content.map((el, index) => (
                <li key={index} className=" whitespace-pre-line">
                  {el}
                </li>
              ))}
            </div>
            <div className="text-right p-6 space-x-2 border-t border-gray-200 rounded-b dark:border-gray-600">
              <button
                data-modal-hide="defaultModal"
                type="button"
                className="text-gray-500 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-blue-300 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600"
                onClick={hideModal}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const Card = ({ productId, photoPath,updateLinks, productName, description,earnUpto, showModal,actualAmount }) => {
  console.log(updateLinks)
  const navigate = useNavigate();
  function checkUserLoggedIn() {
    const token = localStorage.getItem('token');
  
    if (token) {
      return true;
    } else {
      return false;
    }
  }
  const handleShareClick = async () => {
    try {
      const isLoggedIn = checkUserLoggedIn();
      if (!isLoggedIn) {
        navigate('/login');
      } else {
        navigate(`/referral?productId=${productId}`);
      }
    } catch (error) {
      console.error('Error sharing product:', error);
    }
  };
  const handleApplyClick = async () => {
    try {
      const isLoggedIn = checkUserLoggedIn();
      if (!isLoggedIn) {
        navigate('/login');
      } else {
        window.location.href = `${updateLinks}`
      }
    } catch (error) {
      console.error('Error sharing product:', error);
    }
  };
  const imagePath = `https://backend.grahaksathi.in/uploads/${photoPath}`;
  return (
    <div className="flex flex-col items-end top-16 relative bg-[#c4a984] border border-[#c4a984]/90 rounded-md shadow md:flex-row md:max-w-8xl hover:bg-[#c4a984]/60 dark:border-gray-700 dark:bg-gray-800 dark:hover:bg-gray-700 mb-3 lg:mb-6 px-4 py-2">
      <div className="flex lg:flex-wrap w-full lg:w-1/3 lg:ml-5">
        <div className="w-24 lg:w-[15vh]">
          <img className="object-contain w-full rounded-md h-[10vh] lg:h-[15vh] md:rounded-lg" src={imagePath} alt="img" />
        </div>
        <div className="flex items-end mx-2">
          <button
            type="button"
            className="text-white bg-[#6c757d] hover:bg-[#6c757d]/80 focus:ring-2 focus:outline-none focus:ring-[#6c757d]/50 font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center dark:hover:bg-[#050708]/40 dark:focus:ring-gray-600 mr-2 mb-2"
          >
            Earn Upto {earnUpto}/-
          </button>
          <button
            onClick={showModal}
            className="text-white bg-[#6c757d] hover:bg-[#6c757d]/80 focus:ring-2 focus:outline-none focus:ring-[#6c757d]/50 font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center dark:hover:bg-[#050708]/40 dark:focus:ring-gray-600 mr-2 mb-2"
            type="button"
          >
            Benefits
          </button>
        </div>
      </div>
      <div className="flex flex-col leading-normal w-full ">
        <div className=" flex flex-col lg:mr-5">
          <h2 className="mb-2 text-2xl font-bold tracking-tight text-gray-900 dark:text-white">{productName}</h2>
          <h6 className="font-normal text-gray-700 dark:text-gray-400">{description}</h6>
        </div>

        <div className=" flex justify-end lg:mr-5 lg:mt-5">
          <button
            type="button"
            className="text-white bg-[#6c757d] hover:bg-[#6c757d]/80 focus:ring-2 focus:outline-none focus:ring-[#6c757d]/50 font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center dark:hover:bg-[#050708]/40 dark:focus:ring-gray-600 mr-2 mb-2"
            onClick={handleShareClick}
          >
            Share Now
          </button>
          <button
            className="text-white bg-[#6c757d] hover:bg-[#6c757d]/80 focus:ring-2 focus:outline-none focus:ring-[#6c757d]/50 font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center dark:hover:bg-[#050708]/40 dark:focus:ring-gray-600 mr-2 mb-2"
            type="button"
            onClick={handleApplyClick}
          >
            Apply Now
          </button>
        </div>
      </div>
    </div>
  );
};
